import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Overlay, Popover, Button } from 'react-bootstrap';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';

import {
  stopTutorial,
  nextTutorial,
  previousTutorial,
} from '../../actions/TutorialActions';

import s from './Tutorial.css';

/*
 * Presentational component for displaying tutorial popover
 */
const Tutorial = props => {
  const { id, title, text, end, onPrev, onNext, onClose, ...newProps } = props;
  return (
    <Overlay {...newProps}>
      <Popover id={id} title={title}>
        <div>
          {text}
          <br />

          {onClose && (
            <Button
              className={s.button}
              bsStyle="link"
              style={{ float: 'left' }}
              onClick={onClose}
            >
              <i className="fa fa-times" />
            </Button>
          )}

          {onNext && !end && (
            <Button
              className={s.button}
              bsStyle="link"
              style={{ float: 'right' }}
              onClick={onNext}
            >
              <i className="fa fa-arrow-right" />
            </Button>
          )}

          {onPrev && (
            <Button
              className={s.button}
              bsStyle="link"
              style={{ float: 'right' }}
              onClick={onPrev}
            >
              <i className="fa fa-arrow-left" />
            </Button>
          )}
        </div>
      </Popover>
    </Overlay>
  );
};

const TutorialStep = connect(
  (state, props) => ({
    show: state.tutorial.step === props.step,
    id: props.step,
  }),
  (dispatch, props) => ({
    onNext: () => {
      if (props.onNext && typeof props.onNext === 'function') props.onNext();

      dispatch(nextTutorial());
      props.cookies.set('tutorialStep', 1, { path: '/' });
    },
    onPrev:
      props.step === 1
        ? null
        : () => {
            if (props.onPrev && typeof props.onPrev === 'function')
              props.onPrev();

            dispatch(previousTutorial());
            props.cookies.set('tutorialStep', 1, { path: '/' });
          },
    onClose: () => {
      dispatch(stopTutorial());
      props.cookies.set('tutorialStep', 1, { path: '/' });
    },
  }),
)(Tutorial);

export default withStyles(s)(withCookies(TutorialStep));
